import { IFooterLink } from '../../../interfaces/IFooter';
import React from 'react';

interface FooterLinkProps extends IFooterLink {
    key?: number;
    rel?: string;
}

export class FooterLink extends React.Component<FooterLinkProps, {}> {
    render() {
        return (
            <a
                key={this.props.key}
                href={this.props.targetUrl}
                title={this.props.linkTitle}
                rel={this.props.title === 'Agentur-Partner' ? 'nofollow' : this.props.linkTitle}
            >
                {this.props.title}
            </a>
        );
    }
}
